<template>
  <div class="mini-queue-list-box">
    <div class="header-box">
      <div class="title-box">
        <div class="title">任务进度</div>
        <div class="count">{{ getCountRecord() }}</div>
      </div>
      <div class="operation-btn-box">
        <div
          class="icon-box icon-box-maximized"
          @click="maximizedConvertQueue">
          <icon-svg
            icon-class="ic-ico_an"
            size="12"
            class="icon" />
        </div>
        <div
          class="icon-box"
          size="16"
          @click="closeConvertQueue">
          <i class="el-icon-close" />
        </div>
      </div>
    </div>
    <div
      class="loading-box"
      v-if="isLoading">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      class="queue-content-box"
      v-else>
      <div
        class="custom-table-box"
        v-if="queueList.length">
        <div class="table-header-box">
          <div class="name-box">文件名称</div>
          <div class="table-header-item">文件大小</div>
          <div class="table-header-item">状态</div>
          <div class="operation-td-box">操作</div>
        </div>
        <div class="tbody-box">
          <div
            class="tr-box"
            v-for="(item, index) in queueList"
            :key="index">
            <div class="tr">
              <div
                class="name-box two-line-text-overflow"
                :title="item.dataSetName">
                {{ item.dataSetName }}
              </div>
              <div class="td">{{ item.fileSize }}</div>
              <div class="td status-text">
                <div>
                  <span
                    v-if="item.convertStatus === 1"
                    class="queuing-status">
                    排队中
                  </span>
                  <span
                    v-if="item.convertStatus === 2"
                    class="converting-status">
                    {{ item.ratio }}%
                  </span>
                  <span
                    v-if="item.convertStatus === 5"
                    class="stoping-status">
                    停止中
                  </span>
                </div>
              </div>
              <div class="operation-td-box">
                <div class="common-button-box">
                  <el-button
                    type="text"
                    size="small"
                    :disabled="
                      item.convertStatus === 2 || item.convertStatus === 5
                    "
                    @click="moveQueue(item, true)">
                    <div class="icon-box">
                      <icon-svg
                        size="16"
                        icon-class="ic-shangyi" />
                    </div>
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    :disabled="
                      item.convertStatus === 2 || item.convertStatus === 5
                    "
                    @click="moveQueue(item, false)">
                    <div class="icon-box">
                      <icon-svg
                        size="16"
                        icon-class="ic-xiayi" />
                    </div>
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    :title="getCancelBtnTitle(item)"
                    :disabled="item.convertStatus === 5"
                    @click="cancelProjectTransform(item)">
                    <div class="icon-box">
                      <icon-svg
                        size="16"
                        icon-class="ic-quxiao" />
                    </div>
                  </el-button>
                </div>
              </div>
            </div>
            <div
              v-if="item.convertStatus === 2"
              class="custom-progress-box"
              :style="`width:${item.ratio}%`" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'

import { formatFileSize } from '@/utils/generalMethods'

import {
  getSceneConvertQueueService,
  getProjectsConvertingProgress,
  moveConvertQueue,
  stopConvertingProject,
  delQueueProject
} from '@/service/interface'

export default {
  data() {
    return {
      isLoading: false,

      queueList: [],

      // 防止同时存在转换中和排队中的数据集，最后一个转换中的数据集转换成功后，队列清空的问题
      // 解决办法：如果是被动打开(添加数据集，修改数据集配置)转换队列，转换队列为空时，执行指定次数的的请求
      // 如果指定次数的请求后队列依旧为空，则认定队列为空
      requestCount: 0,
      maxRequestCount: 5
    }
  },
  props: {
    closeConvertQueue: Function,
    maximizedConvertQueue: Function,
    updateConvertDataSets: Function
  },
  components: {
    Spin
  },
  watch: {
    queueList: function (newVal, oldVal) {
      let dataSetIds = this.getConvertedDataSetIds(newVal, oldVal)
      if (dataSetIds.length) {
        this.updateConvertDataSets(dataSetIds)
      }
    }
  },
  mounted() {
    this.initQueueList()
  },
  beforeDestroy() {
    this.destroyTimer()

    this.queueList = []
    this.requestCount = 0
  },
  methods: {
    initQueueList() {
      this.isLoading = true

      this.queryQueueList().then(queueList => {
        this.queueList = queueList
        let convertingDataSets = this.queueList.filter(
          el => el.convertStatus === 2
        )

        if (queueList.length) {
          if (!convertingDataSets.length && !this.refreshQueueTimer) {
            this.refreshQueueTimer = setInterval(this.refreshQueueList, 1000)
            this.isLoading = false
            return
          }
        }

        if (this.refreshProgressTimer) {
          clearInterval(this.refreshProgressTimer)
          this.refreshProgressTimer = null
        }
        if (convertingDataSets.length) {
          this.updateConvertProgress(convertingDataSets)

          // prettier-ignore
          this.refreshProgressTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
        }

        this.isLoading = false
      })
    },
    moveQueue(dataSetInfo, moveDirection) {
      let params = {
        dataSetId: dataSetInfo.dataSetId,
        moveDirection
      }
      moveConvertQueue(params).then(response => {
        if (response.isSuccess) {
          this.refreshQueueList().then(() => {
            this.$message.success('移动成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    cancelProjectTransform(dataSetInfo) {
      if (dataSetInfo.convertStatus === 2) {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isStart: false
        }
        stopConvertingProject(params).then(response => {
          if (response.isSuccess) {
            if (!this.refreshQueueTimer) {
              this.refreshQueueTimer = setInterval(this.refreshQueueList, 1000)
              this.$message.success('取消成功')
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isForce: true
        }
        delQueueProject(params).then(response => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success('删除成功')
              this.updateConvertDataSets()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    updateConvertProgress(convertingDataSets) {
      let dataSetIds = convertingDataSets.map(el => el.dataSetId)
      getProjectsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let dataInfo = dataList[i]
            if (dataInfo.ratio === -1) {
              this.refreshQueueList()
              break
            }

            let ratio = Math.round(dataInfo.ratio / 100) / 100
            let find = this.queueList.find(
              el => el.dataSetId === dataInfo.dataSetId
            )

            if (ratio === 100) {
              // 延迟查询，防止当前数据集为最后一个数据集时，队列返回的是空的
              setTimeout(this.refreshQueueList, 500)
              break
            } else {
              this.$set(find, 'ratio', ratio)
              this.$set(find, 'ratioMsg', dataInfo.message)
            }
          }
        }
      })
    },
    refreshQueueList() {
      return new Promise(resolve => {
        this.queryQueueList().then(queueList => {
          queueList.forEach(item => {
            let find = this.queueList.find(
              el => el.dataSetId === item.dataSetId
            )
            if (find && find.ratio) {
              item.ratio = find.ratio
              item.ratioMsg = find.ratioMsg
            }
          })
          this.queueList = queueList

          let convertingDataSets = this.queueList.filter(
            el => el.convertStatus === 2
          )

          if (!queueList.length) {
            this.loopRequestQueueList().then(() => {
              this.refreshQueueTimer && clearInterval(this.refreshQueueTimer)
              this.refreshQueueTimer = null
            })
          }

          if (this.refreshProgressTimer) {
            clearInterval(this.refreshProgressTimer)
            this.refreshProgressTimer = null
          }
          if (convertingDataSets.length && !this.refreshProgressTimer) {
            this.updateConvertProgress(convertingDataSets)
            // prettier-ignore
            this.refreshProgressTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
          }
          resolve()
        })
      })
    },
    loopRequestQueueList() {
      return new Promise(resolve => {
        this.queryQueueList().then(queueList => {
          if (queueList.length) {
            this.queueList = queueList

            let convertingDataSets = queueList.filter(
              el => el.convertStatus === 2
            )
            if (convertingDataSets.length) {
              this.requestCount = 0

              if (!this.queueTimer) {
                this.updateConvertProgress(convertingDataSets)
                // prettier-ignore
                this.queueTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
              }
            }
          } else {
            this.requestCount++
            if (this.requestCount > this.maxRequestCount) {
              this.refreshQueueTimer && clearInterval(this.refreshQueueTimer)
              this.refreshQueueTimer = null
              this.requestCount = 0
              resolve()
            } else {
              this.loopRequestQueueList()
            }
          }
        })
      })
    },
    getConvertedDataSetIds(newVal, oldVal) {
      let dataSetIds = []
      oldVal.forEach(item => {
        let find = newVal.find(el => el.dataSetId === item.dataSetId)
        if (!find) {
          dataSetIds.push(item.dataSetId)
        }
      })
      return dataSetIds
    },
    destroyTimer() {
      if (this.refreshProgressTimer) {
        clearInterval(this.refreshProgressTimer)
        this.refreshProgressTimer = null
      }

      if (this.refreshQueueTimer) {
        clearInterval(this.refreshQueueTimer)
        this.refreshQueueTimer = null
      }
    },
    queryQueueList() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getSceneConvertQueueService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let queueList = this.formatQueueList(data)
            resolve(queueList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatQueueList(queueList) {
      let waiting = []
      let converting = []
      queueList.forEach(item => {
        let size = formatFileSize(item.fileTotalSize).fileSize
        let unit = formatFileSize(item.fileTotalSize).unit
        let fileSize = `${size}${unit}`
        item.fileSize = fileSize

        if (item.convertStatus === 2) {
          converting.push(item)
          if (!item.ratio) {
            item.ratio = 0
            item.ratioMsg = ''
          }
        } else {
          waiting.push(item)
        }
        converting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
        waiting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
      })
      return [...converting, ...waiting]
    },
    getCountRecord() {
      let contentStr = ''
      if (!this.queueList.length) {
        contentStr = '(0)'
        return contentStr
      }

      let convertingCount = this.queueList.filter(el => el.convertStatus === 2)
      contentStr = `(${convertingCount.length}/${this.queueList.length})`

      return contentStr
    },
    getCancelBtnTitle(dataSetInfo) {
      let convertStatus = dataSetInfo.convertStatus
      let title = convertStatus === 1 ? '取消任务' : '停止任务'
      return title
    }
  }
}
</script>

<style lang="less" scoped>
.mini-queue-list-box {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 480px;
  z-index: 2;
  background: var(--scene-queue-bgColor);
  border: 1px solid var(--dialog-footer-border-color);
  border-radius: 8px 8px 0px 0px;

  .header-box {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    border-radius: 8px 8px 0px 0px;
    background: var(--dialog-header-bgColor);

    .title-box {
      display: flex;
      color: var(--dialog-header-text-color);

      .count {
        margin-left: 10px;
        letter-spacing: 2px;
      }
    }

    .operation-btn-box {
      display: flex;
      align-items: center;

      .icon-box {
        display: flex;
        color: var(--dialog-header-text-color);
        cursor: pointer;
        padding: 4px;
        margin-left: 10px;
        border-radius: 4px;

        .icon {
          width: 16px;
          height: 16px;
          font-size: 12px;
          color: var(--dialog-header-icon-color);
        }

        .el-icon-close {
          color: var(--dialog-header-icon-color);
        }

        &:hover {
          background: var(--dialog-header-icon-bgColor);
          border-radius: 4px;
        }
      }
      .icon-box-maximized {
        padding: 6px;
      }
    }
  }

  .loading-box {
    position: relative;
    height: 245px;
  }

  .queue-content-box {
    .custom-table-box {
      margin: 15px;
      color: var(--table-text-color);
      text-align: left;

      .name-box {
        width: 166px;
        flex-shrink: 0;
      }

      .two-line-text-overflow {
        display: -webkit-box;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.5em;
      }

      .operation-td-box {
        width: 84px;
        flex-shrink: 0;
        text-align: center;
      }

      .table-header-box {
        display: flex;
        align-items: center;
        padding: 15px;
        font-size: 14px;

        .table-header-item {
          flex: 1;
          text-align: center;
        }
      }

      .tbody-box {
        max-height: 165px;
        font-size: 12px;
        overflow-y: auto;
        // background: #252525;

        .tr-box {
          position: relative;
          background-color: var(--table-bgColor);
          border-radius: 16px;

          .tr {
            position: relative;
            display: flex;
            align-items: center;
            padding: 2px 15px;
            // border-bottom: 1px solid #303030;
            z-index: 2;
            font-size: 14px;
            border-radius: 16px;
            background-color: var(--table-bgColor);
            margin-bottom: 4px;
            height: 54px;

            .td {
              flex: 1;
              display: flex;
              justify-content: center;
            }

            .queuing-status {
              color: var(--base-light-color24);
              position: relative;

              &::before {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                position: absolute;
                border-radius: 50%;
                background-color: var(--base-light-color24);
                top: 50%;
                left: -12px;
                transform: translateY(-50%);
              }
            }

            .converting-status {
              color: var(--base-primary-bgColor);
              position: relative;

              &::before {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                position: absolute;
                border-radius: 50%;
                background-color: var(--base-primary-bgColor);
                top: 50%;
                left: -12px;
                transform: translateY(-50%);
              }
            }

            .stoping-status {
              color: var(--base-dark25-color);
              position: relative;

              &::before {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                position: absolute;
                border-radius: 50%;
                background-color: var(--base-dark25-color);
                top: 50%;
                left: -12px;
                transform: translateY(-50%);
              }
            }

            .common-button-box {
              display: flex;
              justify-content: flex-end;

              .el-button {
                margin-right: 0px;
                margin-left: 0;
              }
              .icon-box {
                padding: 5px;
                color: var(--table-text-color);
                font-size: 20px;
                border-radius: 4px;

                &:hover {
                  color: var(--base-primary-bgColor);
                }
              }
            }
          }

          .custom-progress-box {
            position: absolute;
            top: 0px;
            width: 23%;
            height: 100%;
            background: var(--scene-queue-progress-bgColor);
            z-index: 2;
            border-top-left-radius: 16px;
            border-bottom-left-radius: 16px;
          }
        }
      }
    }
  }
}
</style>
